import service from '@/plugins/service'

export const getErrorCodeList = type => {
  const data = new FormData()
  data.append('type', type)

  return service({
    url: '/compressor/web/error_code',
    method: 'POST',
    data
  })
}